export default "__VITE_ASSET__lhL_8Wn4__"